import React from 'react';

export function ProofBar() {
  return (
    <div className="w-full border-y border-hairline py-12 overflow-hidden bg-paper">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk text-center">
        <p className="font-mono text-caption text-graphite uppercase tracking-[0.12em] whitespace-nowrap overflow-x-auto no-scrollbar">
          TRUSTED BY FOUNDERS AT &nbsp;·&nbsp; [PARTNER FILLS, five short company descriptors or names, e.g., "A BOSTON SAAS FIRM · A LONDON STAFFING AGENCY · A NEW YORK CONSULTANCY · A SAN FRANCISCO IT SERVICES COMPANY · A MANCHESTER MARKETING AGENCY"]
        </p>
      </div>
    </div>
  );
}